import urls from '../../urls';
import { route } from '../helpers';
import OrderStore from '../../stores/OrderStore';

import { PointStages, CheckoutStages } from '../../constants/AppConstants';

export default route(CheckoutStages.PAYMENT_CONFIRMATION, {
    getComponent(location, cb) {
        require.ensure(
            [],
            (require) => {
                cb(null, require('../../components/checkout/PaymentConfirmation').default);
            },
            () => {
                // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
                // TODO: use a smarter way to get an updated chunk
                window.location.reload();
            },
            'payment-confirmation');
    },

    onEnter (nextState, replace) {
        const paidOrder = OrderStore.getPaid();

        if (!paidOrder || !paidOrder.id) {
            const currentOrder = OrderStore.getCurrent();
            const redirectTo = !currentOrder || currentOrder.isEmpty() ? PointStages.SEARCH : CheckoutStages.PAYMENT;
            replace(urls.location(redirectTo));
        }

    }
});
